import axios from 'axios';

export const GET_SUBMISSION_DETAILS_BEGIN = 'GET_SUBMISSION_DETAILS_BEGIN';
export const GET_SUBMISSION_DETAILS_SUCCESS = 'GET_SUBMISSION_DETAILS_SUCCESS';
export const GET_SUBMISSION_DETAILS_FAILURE = 'GET_SUBMISSION_DETAILS_FAILURE';

export const getSubmissionDetailsBegin = () => ({
    type: GET_SUBMISSION_DETAILS_BEGIN
});

export const getSubmissionDetailsSuccess = (value) => ({
    type: GET_SUBMISSION_DETAILS_SUCCESS,
    payload: value
});

export const getSubmissionDetailsFailure = (error) => ({
    type: GET_SUBMISSION_DETAILS_FAILURE,
    payload: error
});

export const getSubmissionDetailsFromSubmissionId = (webappurlForms, accessToken, submissionId) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
       
        dispatch(getSubmissionDetailsBegin());
        return axios.post(webappurlForms + `/api/myCASA/Forms/Query/Crm/Submission/${submissionId}/v1`, null, options)
            .then(response => {
                if (response.data.wasSuccessful) {
                    return dispatch(getSubmissionDetailsSuccess(response.data.submission));
                }
                else {
                    return dispatch(getSubmissionDetailsFailure(response.data.errors));
                }
            })
            .catch(error => {
                return dispatch(getSubmissionDetailsFailure(error?.response?.data.errors ?? error));
            });
    };
}
